import type { FetchProductsReferentialApi } from 'epic/common-form/fetchProductsReferential';
import type { DynamicProduct, ProductsReferential } from 'models/productsReferential';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';
export function productsReferentialApiConnector(http$: IHttpClient): FetchProductsReferentialApi {
  return {
    fetchProductsReferential(): Observable<ProductsReferential> {
      return http$
        .getJSON<ProductsReferential>({
          url: `api/v1/products-referential`,
        })
        .pipe(map(({ payload }) => payload));
    },
    fetchDynamicProducts(): Observable<readonly DynamicProduct[]> {
      return http$
        .getJSON<readonly DynamicProduct[]>({
          url: `api/v1/dynamic-products`,
        })
        .pipe(map(({ payload }) => payload));
    },
    fetchRecentProducts() {
      return http$
        .getJSON<ProductsReferential>({
          url: `api/v1/products-referential/recent`,
        })
        .pipe(map(({ payload }) => payload ?? {}));
    },
    addToRecentProduct(workspace, variation) {
      return http$.post({
        url: `api/v1/products-referential/recent/${workspace}`,
        body: variation,
      });
    },
  };
}
